import { lazy } from "react";
export const feature = {
    id: "fx-rates",
    nav: [
        {
            label: "Currency Rates",
            icon: "Banknote",
            path: "/fx-rates",
            group: "Platform",
            order: 60,
            actions: ["view"],
            apiPaths: [],
        },
    ],
    routes: [
        {
            path: "/fx-rates",
            component: lazy(() => import("./pages/FxRates.js").then((m) => ({ default: m.FxRates }))),
        },
    ],
};
//# sourceMappingURL=index.js.map